<template>
<div class="wrapper">
    <div class="landing-wrap w-100">
      <div class="container">
        <div class="landing-page-box">
          <!-- nav starts -->
          <div class="landing-nav w-100 d-flex flex-row align-items-center justify-content-between mt-2">
            <img class="logo" style="height: 117px;" src="@/assets/image/landing/logo2.png" alt="foojan" />
            <div class="nav-links mx-auto d-none d-md-flex flex-row justify-content-between align-items-center">
              <router-link to ="model">Our Model</router-link>
              <router-link to ="resources">Resources</router-link>
              <router-link to ="about">About us</router-link>
            </div>
            <div class="d-flex login-signup-btns flex-row align-items-center h-100">
              <router-link to="register"><button class="login-btn" >Signup</button></router-link>
              <router-link to="login"><button class="signup-btn">Login</button></router-link>
            </div>
          </div>
          <!-- nav ends here -->
          <section id="content-area">
            <div class="d-flex flex-md-row flex-column-reverse w-100">
              <div class="left-content-box d-flex flex-column">
                <!-- <h6 class="download-text">Download Foojan App</h6>
                <div class="d-flex flex-row align-items-center pt-2 pb-4">
                  <button class="store app d-flex flex-row px-2 align-items-center">
                    <img src="@/assets/image/landing/apple-logo.png" alt="" />
                    <div class="d-flex flex-column align-items-start">
                      <p class="m-0 btn-first-line">Download on the</p>
                      <p class="m-0 btn-second-line">App Store</p>
                    </div>
                  </button>
                  <button class="mx-2 px-2 store google d-flex flex-row align-items-center">
                    <img src="@/assets/image/landing/google-logo.png" alt="" />
                    <div class="d-flex flex-column align-items-start">
                      <p class="m-0 btn-first-line">GET IT ON</p>
                      <p class="m-0 btn-second-line">Google Play</p>
                    </div>
                  </button>
                </div> -->
              </div>
              <div class="right-content-box d-flex flex-column">
                <div class="right-inner-wrap d-flex flex-column">
                  <h1>
                    Empowering
                    <br />
                    <h3>The Inner Voice</h3>
                  </h1>
                  <div class="download-div">
                  <h6 class="download-text">Download Foojan App</h6>
                    <div class="d-flex flex-row align-items-center pt-2 pb-4" style="margin-left: 39%;">
                      <button class="store app d-flex flex-row px-2 align-items-center">
                        <img src="@/assets/image/landing/apple-logo.png" alt="" />
                        <div class="d-flex flex-column align-items-start">
                          <p class="m-0 btn-first-line">Download on the</p>
                          <p class="m-0 btn-second-line">App Store</p>
                        </div>
                      </button>
                      <button class="mx-2 px-2 store google d-flex flex-row align-items-center">
                        <img src="@/assets/image/landing/google-logo.png" alt="" />
                        <div class="d-flex flex-column align-items-start">
                          <p class="m-0 btn-first-line">GET IT ON</p>
                          <p class="m-0 btn-second-line">Google Play</p>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="owl-carousel owl-theme">
                    <!-- <h6 class="download-text">Download Foojan App</h6>
                    <div class="d-flex flex-row align-items-center pt-2 pb-4">
                      <button class="store app d-flex flex-row px-2 align-items-center">
                        <img src="@/assets/image/landing/apple-logo.png" alt="" />
                        <div class="d-flex flex-column align-items-start">
                          <p class="m-0 btn-first-line">Download on the</p>
                          <p class="m-0 btn-second-line">App Store</p>
                        </div>
                      </button>
                      <button class="mx-2 px-2 store google d-flex flex-row align-items-center">
                        <img src="@/assets/image/landing/google-logo.png" alt="" />
                        <div class="d-flex flex-column align-items-start">
                          <p class="m-0 btn-first-line">GET IT ON</p>
                          <p class="m-0 btn-second-line">Google Play</p>
                        </div>
                      </button>
                    </div> -->
                    <!-- <div class="item" v-if="index === 0">
                      <div class="slide-card">
                        <div class="top">
                          <img class="user-img" src="@/assets/image/landing/girl.png" alt="">
                          <div class="d-flex flex-column">
                            <h6 class="user-name">Sasha Perry</h6>
                            <div class="rating d-flex flex-row align-items-center">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-blank.png" alt="">
                            </div>
                          </div>
                        </div>
                        <div class="bottom">
                          Lorem ipsum dolor sit amet, consectetur adip iscing elit. Erat elit quam at mattis. Sed nunc
                          aliquam risus purus enim, vestibulum at gravid gravida. Eu id diam, urna eget.
                        </div>
                      </div>
                    </div>
                    <div class="item" v-if="index === 1">
                      <div class="slide-card">
                        <div class="top">
                          <img class="user-img" src="@/assets/image/landing/girl.png" alt="">
                          <div class="d-flex flex-column">
                            <h6 class="user-name">Sasgsgsha Perry</h6>
                            <div class="rating d-flex flex-row align-items-center">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-blank.png" alt="">
                            </div>
                          </div>
                        </div>
                        <div class="bottom">
                          Lorem ipsum dolor sit amet, consectetur adip iscing elit. Erat elit quam at mattis. Sed nunc
                          aliquam risus purus enim, vestibulum at gravid gravida. Eu id diam, urna eget.
                        </div>
                      </div>
                    </div>
                    <div class="item" v-if="index === 2">
                      <div class="slide-card">
                        <div class="top">
                          <img class="user-img" src="@/assets/image/landing/girl.png" alt="">
                          <div class="d-flex flex-column">
                            <h6 class="user-name">Sashgsgsga Perry</h6>
                            <div class="rating d-flex flex-row align-items-center">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-filled.png" alt="">
                              <img class="star" src="@/assets/image/landing/star-blank.png" alt="">
                            </div>
                          </div>
                        </div>
                        <div class="bottom">
                          Lorem ipsum dolor sit amet, consectetur adip iscing elit. Erat elit quam at mattis. Sed nunc
                          aliquam risus purus enim, vestibulum at gravid gravida. Eu id diam, urna eget.
                        </div>
                      </div>
                    </div> -->
                  </div>
                  <!-- <div class="slider_nav d-flex flex-row justify-content-between w-100">
                    <button class="am-next" style="margin-left: 24%;" @click="back"><i class="fas fa-arrow-left"></i></button>
                    <span class="index">{{index+1}}</span>
                    <button class="am-prev" style="margin-right: 24%;" @click="next"><i class="fas fa-arrow-right"></i></button>
                  </div> -->
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <footer id="landing-footer" class="d-none d-md-block">
        <div class="container text-light h-100">
          <div class="d-flex flex-row h-100 align-items-center justify-content-between text-light">
            <div class="left-footer-area d-flex flex-column justify-content-end">
              <h4>Foojan</h4>
              <h6>All copyright revised by foojan.com</h6>
            </div>
            <div class="right-footer-area d-flex flex-row justify-content-between align-items-center">
              <router-link to="home">Home</router-link>
              <router-link to="terms_conditions">Term & Conditions</router-link>
              <router-link to="privacy_policy">Privacy Policy</router-link>
              <router-link to="contact_us">Contact Us</router-link>
              <router-link to="support">Support</router-link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<style scoped>
@import "./../assets/css/home.css";
.login-btn:hover{
  border: none;
  background: linear-gradient(115.41deg, #2c84c4 20.05%, #6eb44e 85.17%);
}
.signup-btn:hover{
  border: none;
  background: linear-gradient(115.41deg, #2c84c4 20.05%, #6eb44e 85.17%);
}
.index {
  color: antiquewhite;
  margin-top: 2%;
}
</style>
<script>
export default {
  data () {
    return {
      index: 0
    }
  },
  methods: {
    next () {
      if (this.index === 2) {
        this.index = 0
      } else {
        this.index = this.index + 1
      }
    },
    back () {
      if (this.index === 0) {
        this.index = 2
      } else {
        this.index = this.index - 1
      }
    }
  },
  mounted: function () {
    console.log(this.index)
    this.index = 0
  }
}
</script>
